// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./estrellaDammCup.jpg')
const productImageCatalan = require('./estrellaDammCupCatalan.jpg')
const allTwoEs = require('./static-2.png')
const allTwoCa = require('./static-2-Ca.png')
const allFourEs = require('./static-2.png')
const allFourCa = require('./static-2-Ca.png')
const catalogTwoEs = require('./static-2.png')
const catalogTwoCa = require('./static-2-Ca.png')
const catalogFourEs = require('./static-2.png')
const catalogFourCa = require('./static-2-Ca.png')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  productImageCatalan,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
